import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormVerificationService } from 'app/shared/services/form-verification.service';
import { LocalStorageService, ObjetsService } from '../../shared';

@Component({
  selector: 'app-form-f',
  templateUrl: './app-form-f.component.html'
})
export class AppFormFComponent implements OnInit {
  public priceTip = "Merci de saisir un montant valide avec des virgules pour séparer les décimales, sans séparateur de millier (ex: 100500,54)";
  public pricePlaceHolder = "Montant (ex: 100500,54)";
  public formName = 'rubrique_F_modalite_cession';
  public metaData: any = [];
  public datasInsee: any = [];
  public datasSection: any = [];
  public datasAlienation: any = [];
  public datasAlienationList: any = [];
  public datasAlienationAdjudication: any;
  public datasAlienationVente: any;
  public formIsValid = true;
  public new = false;

  /**
   * Liste des communes. Alimentée de l'extérieur par form-dia.
   * Le setter re-synchronise les selects localité des parcelles d'échange
   * après que les options sont rendues, car patchValue s'exécute avant l'arrivée des données.
   */
  private _datas: any = [];
  get datas() { return this._datas; }
  set datas(value: any) {
    this._datas = value;
    if (value && value.length > 0) {
      setTimeout(() => {
        const epControls = this.echangeParcelleData.controls;
        for (let i = 0; i < epControls.length; i++) {
          const currentValue = epControls[i].get('refcad_localite').value;
          if (currentValue && currentValue !== '' && currentValue !== 'null') {
            epControls[i].get('refcad_localite').setValue(currentValue, { emitEvent: false });
          }
        }
      });
    }
  }

  private alive = true;
  private validRefCad: any = [];
  private mutating = false;

  loading: any = [];
  loadingSection: any = [];
  public hiddenItems: any = [];
  public showItems: any = [];
  private lineIndex = 0;

  typeVente: FormGroup;
  modalitePaiement: FormGroup;
  echangeParcelle: FormGroup;
  echangeMontant: FormGroup;
  adjudication: FormGroup;

  items: FormArray;
  itemsTv: FormArray;
  itemsEchange: FormArray;
  itemsEchangeMontant: FormArray;
  itemsAdjudication: FormArray;

  constructor(
    private _objetsService: ObjetsService,
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService
  ) {}

  get typeVenteData() { return <FormArray>this.typeVente.get('itemsTv'); }
  get modalitePaiementData() { return <FormArray>this.modalitePaiement.get('items'); }
  get echangeParcelleData() { return <FormArray>this.echangeParcelle.get('itemsEchange'); }
  get echangeMontantData() { return <FormArray>this.echangeMontant.get('itemsEchangeMontant'); }
  get adjudicationData() { return <FormArray>this.adjudication.get('itemsAdjudication'); }

  ngOnInit (): void {
    this.loadListeAlienation();

    this.loading[0] = false;

    this.showItems[0] = true;
    this.modalitePaiement = new FormGroup({
      f_1__prix_vente_eva: new FormControl('', Validators.required),
      f_1__prix_vente_eva_texte: new FormControl(),
      f_1__tva_montant: new FormControl(),
      f_1_dont__mobilier: new FormControl(),
      f_1_dont__autres: new FormControl(),
      f_1_dont__autres_precisions: new FormControl(),
      f_1__modalite_paiement__montant: new FormControl(),
      f_1__modalite_paiement__taxe: new FormControl(),
      f_1__modalite_paiement__beneficiaire: new FormControl(),
      f_1__adresse_bien_indissociable: new FormControl(),
      f_1__modalite_paiement: new FormGroup({
          cerfaValue: new FormControl(),
          code: new FormControl(),
        }, Validators.required),
      f_1__modalite_paiement__comptant: new FormControl(),
      f_1__modalite_paiement__comptant__text: new FormControl(),
      f_1__modalite_paiement__paiement_nature__designation: new FormControl(),
      f_1__modalite_paiement__paiement_nature__evaluation: new FormControl(),
      f_1__modalite_paiement__rente_viagere__montant_annuel: new FormControl(),
      f_1__modalite_paiement__rente_viagere__montant_comptant: new FormControl(),
      f_1__modalite_paiement__rente_viagere__beneficiaire: new FormControl(),
      f_1__modalite_paiement__droit_usage: new FormControl(),
      f_1__modalite_paiement__droit_usage__evaluation: new FormControl(),
      f_1__modalite_paiement__vente_nue_propriete: new FormControl(),
      f_1__modalite_paiement__apport_societe__beneficiaire: new FormControl(),
      f_1__modalite_paiement__apport_societe__estimation: new FormControl(),
      f_1__modalite_paiement__cession__estimation_terrain: new FormControl(),
      f_1__modalite_paiement__cession__estimation_locaux: new FormControl(),
      f_1__modalite_paiement__location_accession__estimation: new FormControl(),
    });

    this.echangeParcelle = new FormGroup({
      refcad_localite: new FormControl(),
      refcad_prefixe: new FormControl(null),
      refcad_section: new FormControl('', Validators.required),
      refcad_numero: new FormControl('', Validators.required),
      refcad_lieu_dit: new FormGroup({
        rivoli: new FormControl(),
        lib: new FormControl()
      }),
      refcad_superficie: new FormControl(),
    });

    this.echangeMontant = new FormGroup({
      f_1__modalite_paiement__echange__montant: new FormControl(),
      f_1__modalite_paiement__echange__proprietaires: new FormControl(),
    });

    this.typeVente = new FormGroup({
      f_type_vente: new FormControl('', Validators.required),
    });

    this.adjudication = new FormGroup({
      f_2__adjudication: new FormControl(),
      f_2__adjudication__date: new FormControl(),
      f_2__adjudication__lieu: new FormControl(),
      f_2__adjudication__montant: new FormControl('', Validators.required)
    });

    this.modalitePaiement = this.formBuilder.group({
      items: this.formBuilder.array([ this.createItem('') ])
    });

    this.echangeParcelle = this.formBuilder.group({
      itemsEchange: this.formBuilder.array([ this.createItem('ep') ])
    });

    this.echangeMontant = this.formBuilder.group({
      itemsEchangeMontant: this.formBuilder.array([ this.createItem('em') ])
    });

    this.typeVente = this.formBuilder.group({
      itemsTv: this.formBuilder.array([ this.createItem('tv') ])
    });

    this.adjudication = this.formBuilder.group({
      itemsAdjudication: this.formBuilder.array([ this.createItem('ad') ])
    });

    this.restoreFromStorage();

    // Auto-sauvegarder le brouillon du formulaire pendant la saisie
    this.typeVente.valueChanges.subscribe(() => this.saveToStorage());
    this.modalitePaiement.valueChanges.subscribe(() => this.saveToStorage());
    this.echangeParcelle.valueChanges.subscribe(() => {
      if (!this.mutating) { this.saveToStorage(); }
    });
    this.echangeMontant.valueChanges.subscribe(() => this.saveToStorage());
    this.adjudication.valueChanges.subscribe(() => this.saveToStorage());
  }

  getPrixVenteMessage(value: string): string {
    if (!value) { return ''; }
    const str = String(value);
    if (!str.includes('.') && !str.includes(',')) { return ''; }
    const normalized = str.replace(',', '.');
    const parts = normalized.split('.');
    const euros = parseInt(parts[0], 10) || 0;
    const centimesStr = (parts[1] || '0').substring(0, 2);
    const centimesRaw = centimesStr.length < 2 ? centimesStr + '0' : centimesStr;
    const centimes = parseInt(centimesRaw, 10);
    const eurosLabel = euros <= 1 ? 'euro' : 'euros';
    const centimesLabel = centimes <= 1 ? 'centime' : 'centimes';
    return `Vous avez saisi : ${euros.toLocaleString('fr-FR')} ${eurosLabel} et ${centimes} ${centimesLabel}`;
  }

  verificationMontant(id: string): any
  {
    const element = <HTMLInputElement> document.getElementById(id);
    if (!element) { return ''; }
    const value = element.value;
    // Ne pas afficher d'erreur si le champ est vide ou à sa valeur par défaut (0)
    if (value === '' || value === '0') {
      return '';
    }
    const matches = String(value).match(FormVerificationService.REGEX_MONTANT);
    if (matches != null) {
      const normalized = value.replace(',', '.');
      const numericValue = parseFloat(normalized);
      if (numericValue <= 0) {
        return 'is-invalid';
      }
      return '';
    } else {
      return 'is-invalid';
    }
  }

  /**
   * Ajoute un lot pour la vente par échange de bien
   *
   * @param i
   */
  addItem(i): void {
    const currentParcelle = this.echangeParcelle.get('itemsEchange').get(i.toString());
    let valid = currentParcelle.valid;

    this.validRefCad[i] = valid;

    const currentParcelleData = currentParcelle.value;
    // Eviter de valider une parcelle vide
    /*if(currentParcelleData.refcad_localite.trim().length == 0 ||
    currentParcelleData.refcad_numero.trim().length == 0 ||
    currentParcelleData.refcad_section.trim().length == 0) {
      valid = false;
    }*/

    if (valid) {
      this.mutating = true;
      this.lineIndex = this.lineIndex + 1;
      this.showItems[this.lineIndex] = true;

      this.itemsEchange = this.echangeParcelle.get('itemsEchange') as FormArray;
      this.itemsEchange.push(this.createItem('ep'));

      this.hiddenItems[i] = true;
      this.showItems[i] = false;
      this.mutating = false;

      this.saveToStorage();
    } else {
    }
  }

  /**
   * Affiche le formulaire d'un lot pour la vente par échange de bien
   *
   * @param i
   */
  showItem(i): void {
    if (this.hiddenItems[i]) {
      this.hiddenItems[i] = false;
    } else {
      this.hiddenItems[i] = true;
    }

    this.saveToStorage();
  }

  /**
   * Si la checkbox nouvelle étude est cochée cette fonction réinitialise les champs de l'étude
   */
  setSectionFieldsNew(): void {
    this.new = !this.new;
  }

  /**
   * Supprime un lot pour la vente par échange de bien
   *
   * @param i
   */
  deleteItem(i): void {
    this.mutating = true;
    this.hiddenItems.splice(i, 1);
    this.itemsEchange.removeAt(i);
    this.lineIndex = this.lineIndex - 1;
    this.showItems[this.lineIndex] = true;
    this.mutating = false;

    this.saveToStorage();
  }

  /**
   * Appel le webservice récupérant la liste des lieux dit en fonction du code INSEE de la commune
   *
   * @param insee
   * @param idPars
   */
  loadListeLieuDit(insee, idPars, restoreValue?: any): void {
    this._objetsService.listeLieuDit(insee).takeWhile(() => this.alive).subscribe(
      result => {
        this.datasInsee[idPars] = result;
        this.loading[idPars] = false;
        // Après que les options sont rendues, forcer la re-synchronisation du select
        if (restoreValue !== undefined) {
          setTimeout(() => {
            this.echangeParcelleData.at(idPars).get('refcad_lieu_dit').setValue(restoreValue, { emitEvent: false });
          });
        }
      },
      error => { this.metaData = <any>error }
    );
  }

  /**
   * Appel le webservice récupérant la liste des lieux dit en fonction du code INSEE de la commune
   *
   * @param insee
   * @param idPars
   */
  loadlisteSectionByInsee(insee, idPars, restoreValue?: any): void {
    this._objetsService.listeSectionByInsee(insee).takeWhile(() => this.alive).subscribe(
      result => {
        this.datasSection[idPars] = result;
        this.loadingSection[idPars] = false;
        // Après que les options sont rendues, forcer la re-synchronisation du select
        if (restoreValue !== undefined) {
          setTimeout(() => {
            this.echangeParcelleData.at(idPars).get('refcad_section').setValue(restoreValue, { emitEvent: false });
          });
        }
      },
      error => { this.metaData = <any>error }
    );
  }

  /**
   * Fournis le code INSEE à la fonction loadListeLieuDit
   *
   * @param insee
   * @param idPars
   */
  communeSelection(insee, idPars, restoreSection?: any, restoreLieuDit?: any): void {
    this.loading[idPars] = true;
    this.loadingSection[idPars] = true;
    this.datasInsee[idPars] = null;
    this.datasSection[idPars] = null;
    this.loadListeLieuDit(insee, idPars, restoreLieuDit);
    this.loadlisteSectionByInsee(insee, idPars, restoreSection);
  }

  /**
   * Appel le webservice récupérant la liste des aliénations
   *
   */
  loadListeAlienation(): void {
    this._objetsService.listeAlienation().takeWhile(() => this.alive).subscribe(
      result => {

        for( const dataAlination of result) {
          if (dataAlination.cerfaValue === null && dataAlination.code !== 11) {
            switch (dataAlination.code) {
              case 1:
                this.datasAlienationVente = dataAlination;
                break;
              case 4:
                this.datasAlienationAdjudication = dataAlination;
                break;
            }
          } else {
            this.datasAlienationList.push(dataAlination);
          }
        }

        // Après que les options sont rendues, forcer la re-synchronisation
        // des radio buttons f_type_vente et du select f_1__modalite_paiement
        // dont les valeurs ont été restaurées avant l'arrivée des données async
        setTimeout(() => {
          const currentTypeVente = this.typeVenteData.at(0).get('f_type_vente').value;
          if (currentTypeVente !== null && currentTypeVente !== '') {
            this.typeVenteData.at(0).get('f_type_vente').setValue(currentTypeVente, { emitEvent: false });
          }

          if (this.datasAlienationList.length > 0) {
            const currentValue = this.modalitePaiementData.at(0).get('f_1__modalite_paiement').value;
            if (currentValue && currentValue.code) {
              this.modalitePaiementData.at(0).get('f_1__modalite_paiement').setValue(currentValue, { emitEvent: false });
            }
          }
        });
      },
      error => { this.metaData = <any>error }
    );
  }

  consoleLog(value) {
    console.log(value);
  }

  /**
   * Réinitialise les champs en les désactivant en cas de changement sur les champs à choix
   */
  resetFormRubrique() {
    const choixVente = this.typeVente.get('itemsTv').get('0').get('f_type_vente').value;
    const choixModal = this.modalitePaiement.get('items').get('0').get('f_1__modalite_paiement').value;

    const listFieldModal = ['f_1__modalite_paiement__comptant',
      'f_1__modalite_paiement__comptant__text',
      'f_1__modalite_paiement__paiement_nature__designation',
      'f_1__modalite_paiement__paiement_nature__evaluation',
      'f_1__modalite_paiement__rente_viagere__montant_annuel',
      'f_1__modalite_paiement__rente_viagere__montant_comptant',
      'f_1__modalite_paiement__droit_usage',
      'f_1__modalite_paiement__droit_usage__evaluation',
      'f_1__modalite_paiement__vente_nue_propriete',
      'f_1__modalite_paiement__apport_societe__beneficiaire',
      'f_1__modalite_paiement__apport_societe__estimation',
      'f_1__modalite_paiement__cession__estimation_terrain',
      'f_1__modalite_paiement__cession__estimation_locaux',
      'f_1__modalite_paiement__location_accession__estimation'];

    switch (choixVente) {
      case 1:
        this._objetsService.setRubriqueFCheckButtonDisableF(false);
        this.adjudication.get('itemsAdjudication').get('0').get('f_2__adjudication__montant').disable();
        this.modalitePaiement.get('items').get('0').get('f_1__modalite_paiement__montant').enable();
        this.modalitePaiement.get('items').get('0').get('f_1__modalite_paiement__taxe').enable();
        this.modalitePaiement.get('items').get('0').get('f_1__modalite_paiement').enable();
        this.adjudication.reset();
        this.modalitePaiement.enable();
        this.echangeParcelle.enable();
        this.echangeMontant.enable();
        break;
      case 4:
        this._objetsService.setRubriqueFCheckButtonDisableF(true);
        this.modalitePaiement.get('items').get('0').get('f_1__modalite_paiement').setValue(null);
        this.adjudication.get('itemsAdjudication').get('0').get('f_2__adjudication__montant').enable();
        this.modalitePaiement.get('items').get('0').get('f_1__modalite_paiement__montant').disable();
        this.modalitePaiement.get('items').get('0').get('f_1__modalite_paiement__taxe').disable();
        this.modalitePaiement.get('items').get('0').get('f_1__modalite_paiement').disable();
        this.modalitePaiement.disable();
        this.echangeParcelle.disable();
        this.echangeMontant.disable();
        break;
    }

    if (choixModal !== null) {
      for (const field of listFieldModal) {
        switch (choixModal.code) {
          case 11:
            if (field !== 'f_1__modalite_paiement__comptant' && field !== 'f_1__modalite_paiement__comptant__text') {
              this.modalitePaiement.get('items').get('0').get(field).disable();
            } else {
              this.modalitePaiement.get('items').get('0').get(field).enable();
            }
            break;
          case 2:
            if (field !== 'f_1__modalite_paiement__paiement_nature__designation' && field !== 'f_1__modalite_paiement__paiement_nature__evaluation') {
              this.modalitePaiement.get('items').get('0').get(field).disable();
            } else {
              this.modalitePaiement.get('items').get('0').get(field).enable();
            }
            break;
          case 6:
            if (field !== 'f_1__modalite_paiement__rente_viagere__montant_annuel' &&
              field !== 'f_1__modalite_paiement__rente_viagere__montant_comptant' &&
              field !== 'f_1__modalite_paiement__rente_viagere__beneficiaire') {
              this.modalitePaiement.get('items').get('0').get(field).disable();
            } else {
              this.modalitePaiement.get('items').get('0').get(field).enable();
            }
            break;
          case 5:
            if (field !== 'f_1__modalite_paiement__apport_societe__beneficiaire' && field !== 'f_1__modalite_paiement__apport_societe__estimation') {
              this.modalitePaiement.get('items').get('0').get(field).disable();
            } else {
              this.modalitePaiement.get('items').get('0').get(field).enable();
            }
            break;
          case 7:
            if (field !== 'f_1__modalite_paiement__vente_nue_propriete') {
              this.modalitePaiement.get('items').get('0').get(field).disable();
            } else {
              this.modalitePaiement.get('items').get('0').get(field).enable();
            }
            break;
          case 8:
            if (field !== 'f_1__modalite_paiement__cession__estimation_terrain' && field !== 'f_1__modalite_paiement__cession__estimation_locaux') {
              this.modalitePaiement.get('items').get('0').get(field).disable();
            } else {
              this.modalitePaiement.get('items').get('0').get(field).enable();
            }
            break;
          case 9:
            if (field !== 'f_1__modalite_paiement__location_accession__estimation') {
              this.modalitePaiement.get('items').get('0').get(field).disable();
            } else {
              this.modalitePaiement.get('items').get('0').get(field).enable();
            }
            break;
          case 10:
            if (field !== 'f_1__modalite_paiement__droit_usage' && field !== 'f_1__modalite_paiement__droit_usage__evaluation') {
              this.modalitePaiement.get('items').get('0').get(field).disable();
            } else {
              this.modalitePaiement.get('items').get('0').get(field).enable();
            }
            break;
          case 3:
            this.modalitePaiement.get('items').get('0').get(field).disable();
            break;
        }
      }

      if (choixModal.code === 3) {
        const formInit = this.echangeParcelleData.controls[this.echangeParcelleData.controls.length - 1];
        this.echangeParcelleData.controls = [];
        this.echangeParcelleData.controls.push(formInit);
        this.lineIndex = 0;
        this.hiddenItems = [];
        this.showItems = [];
        this.showItems.push(true);
      }
    }
  }

  disableOnUncheck(fieldName, fieldNameText): void {
    const choix = this.modalitePaiementData.get('0').get(fieldName).value;

    if (choix === 'PartieComptant') {
      this.modalitePaiementData.get('0').get(fieldNameText).enable();
    } else {
      this.modalitePaiementData.get('0').get(fieldNameText).disable();
    }
  }

  /**
   * Fonction gérant l'affichage des messages de non validités des champs des parcelles d'échange
   *
   * @param dirty
   * @param i
   * @param {string} type
   * @returns {any}
   */
   checkFieldValidity(dirty, i, type = 'validity'): any {
    const valid = this.validRefCad[i];

    switch (type) {
      case 'class':
        if (valid === false && !dirty) {
          return 'is-invalid';
        } else {
          return '';
        }
      default:
        if (valid === false && !dirty) {
          return true;
        } else {
          return false;
        }
    }
  }

  /**
   * Fonction gérant l'affichage des erreurs sur les champs obligatoires du formulaire principal
   * (type de vente, prix de vente, modalité de paiement, montant adjudication).
   * Utilise formIsValid qui est mis à false par le parent quand la validation échoue.
   *
   * @param dirty
   * @param {string} type
   * @returns {any}
   */
  checkMainFieldValidity(dirty, type = 'validity'): any {
    switch (type) {
      case 'class':
        if (!this.formIsValid && !dirty) {
          return 'is-invalid';
        } else {
          return '';
        }
      default:
        if (!this.formIsValid && !dirty) {
          return true;
        } else {
          return false;
        }
    }
  }

  getAlienation(type, libValue): any {
    if (type === 'vente') {
      if (typeof this.datasAlienationVente !== 'undefined') {
        if (this.datasAlienationVente.hasOwnProperty('code') && this.datasAlienationVente.hasOwnProperty('lib'))  {
          if (libValue === 'code') {
            return this.datasAlienationVente.code;
          } else if (libValue === 'lib') {
            return this.datasAlienationVente.lib;
          }
        }
      }
    } else if (type === 'adj') {
      if (typeof this.datasAlienationAdjudication !== 'undefined') {
        if (this.datasAlienationAdjudication.hasOwnProperty('code') && this.datasAlienationAdjudication.hasOwnProperty('lib'))  {
          if (libValue === 'code') {
            return this.datasAlienationAdjudication.code;
          } else if (libValue === 'lib') {
            return this.datasAlienationAdjudication.lib;
          }
        }
      }
    }
  }

  isSuperficieInvalide(item: FormGroup) {
    const surface = Number(item.controls.refcad_superficie.value);
    return !Number.isFinite(surface) || surface <= 0;
  }

  /**
   *
   * @param type
   * @returns {FormGroup}
   */
  createItem(type): FormGroup {
    if (type === 'tv') {
      return this.formBuilder.group({
        f_type_vente: '',
      });
    } if (type === 'ep') {
      return this.formBuilder.group({
        refcad_localite: '',
        refcad_prefixe: null,
        refcad_section: '',
        refcad_numero: null,
        refcad_lieu_dit: {},
        refcad_superficie: null
      });
    } if (type === 'em') {
      return this.formBuilder.group({
        f_1__modalite_paiement__echange__montant: 0,
        f_1__modalite_paiement__echange__proprietaires: '',
      });
    } if (type === 'ad') {
      return this.formBuilder.group({
        f_2__adjudication: null,
        f_2__adjudication__date: '',
        f_2__adjudication__lieu: '',
        f_2__adjudication__montant: ''
      });
    } else {
      return this.formBuilder.group({
        f_1__prix_vente_eva: '',
        f_1__prix_vente_eva_texte: '',
        f_1__tva_montant: 0,
        f_1_dont__mobilier: 0,
        f_1_dont__autres: 0,
        f_1_dont__autres_precisions: '',
        f_1__modalite_paiement__montant: 0,
        f_1__modalite_paiement__taxe: true,
        f_1__modalite_paiement__beneficiaire: '',
        f_1__adresse_bien_indissociable: '',
        f_1__modalite_paiement: null,
        f_1__modalite_paiement__comptant: '',
        f_1__modalite_paiement__comptant__text: '',
        f_1__modalite_paiement__paiement_nature__designation: '',
        f_1__modalite_paiement__paiement_nature__evaluation: 0,
        f_1__modalite_paiement__rente_viagere__montant_annuel: 0,
        f_1__modalite_paiement__rente_viagere__montant_comptant: 0,
        f_1__modalite_paiement__rente_viagere__beneficiaire: '',
        f_1__modalite_paiement__droit_usage: '',
        f_1__modalite_paiement__droit_usage__evaluation: 0,
        f_1__modalite_paiement__vente_nue_propriete: '',
        f_1__modalite_paiement__apport_societe__beneficiaire: '',
        f_1__modalite_paiement__apport_societe__estimation: 0,
        f_1__modalite_paiement__cession__estimation_terrain: 0,
        f_1__modalite_paiement__cession__estimation_locaux: 0,
        f_1__modalite_paiement__location_accession__estimation: 0,
      });
    }
  }

  /**
   * Comparateur pour la select box lieu-dit :
   * compare par rivoli pour éviter les problèmes de référence après désérialisation JSON.
   */
  compareLieuDit(a: any, b: any): boolean {
    if (!a || !b) { return a === b; }
    return a.rivoli === b.rivoli;
  }

  /**
   * Comparateur pour la select box modalité de paiement :
   * compare par code pour éviter les problèmes de référence après désérialisation JSON.
   */
  compareAlienation(a: any, b: any): boolean {
    if (!a || !b) { return a === b; }
    return a.code === b.code;
  }

  /**
   * Sauvegarde le brouillon dans le localStorage.
   */
  private saveToStorage(): void {
    // Parcelles d'échange enregistrées (exclure la dernière entrée vide)
    const epControls = this.echangeParcelleData.controls;
    const parcels = [];
    for (let i = 0; i < epControls.length - 1; i++) {
      parcels.push(epControls[i].value);
    }

    const currentParcelForm = this.showItems[this.lineIndex]
      ? this.echangeParcelleData.at(this.lineIndex).value
      : null;

    // Utiliser getRawValue() pour préserver les valeurs des champs désactivés
    // (ex: modalitePaiement désactivé quand adjudication est sélectionnée)
    const modalitePaiementGroup = this.modalitePaiementData.at(0) as FormGroup;
    const echangeMontantGroup = this.echangeMontantData.at(0) as FormGroup;
    const adjudicationGroup = this.adjudicationData.at(0) as FormGroup;

    this.localStorageService.save('form_f', {
      typeVente: this.typeVenteData.at(0).value,
      modalitePaiement: modalitePaiementGroup.getRawValue(),
      parcels,
      currentParcelForm,
      echangeMontant: echangeMontantGroup.getRawValue(),
      adjudication: adjudicationGroup.getRawValue(),
      newSection: this.new
    });
  }

  /**
   * Restaure le brouillon depuis le localStorage.
   * Reconstruit le FormArray des parcelles d'échange et relance les appels API pour
   * les selects cascadés. Réapplique l'état enabled/disabled des champs conditionnels.
   */
  private restoreFromStorage(): void {
    const saved = this.localStorageService.load('form_f');
    if (!saved) { return; }

    // Restaurer typeVente
    if (saved.typeVente) {
      this.typeVenteData.at(0).patchValue(saved.typeVente, { emitEvent: false });
    }

    // Restaurer modalitePaiement
    if (saved.modalitePaiement) {
      this.modalitePaiementData.at(0).patchValue(saved.modalitePaiement, { emitEvent: false });
    }

    // Restaurer echangeMontant
    if (saved.echangeMontant) {
      this.echangeMontantData.at(0).patchValue(saved.echangeMontant, { emitEvent: false });
    }

    // Restaurer adjudication
    if (saved.adjudication) {
      this.adjudicationData.at(0).patchValue(saved.adjudication, { emitEvent: false });
    }

    // Restaurer le flag "nouvelle section"
    if (saved.newSection) {
      this.new = true;
    }

    // Réappliquer l'état enabled/disabled des champs conditionnels
    // IMPORTANT : doit être appelé AVANT la restauration des parcelles car
    // resetFormRubrique() réinitialise le FormArray des parcelles pour le code 3 (échange)
    this.resetFormRubrique();

    // Restaurer les parcelles d'échange APRÈS resetFormRubrique()
    // pour éviter que le bloc code === 3 n'écrase les parcelles restaurées
    const savedParcels: any[] = saved.parcels;
    if (savedParcels && savedParcels.length > 0) {
      // RAZ
      this.mutating = true;
      while (this.echangeParcelleData.length > 0) {
        this.echangeParcelleData.removeAt(0);
      }
      this.hiddenItems = [];
      this.showItems = [];

      // Première entrée
      const firstEp = this.createItem('ep');
      this.echangeParcelleData.push(firstEp);
      this.echangeParcelleData.at(0).patchValue(savedParcels[0], { emitEvent: false });
      this.hiddenItems[0] = true;
      this.showItems[0] = false;

      // Relancer le chargement des sections et lieux-dits pour la première parcelle
      const firstLocalite = savedParcels[0].refcad_localite;
      if (firstLocalite && firstLocalite !== '' && firstLocalite !== 'null') {
        this.communeSelection(firstLocalite, 0, savedParcels[0].refcad_section, savedParcels[0].refcad_lieu_dit);
      }

      // Ajouter les parcelles suivantes
      for (let i = 1; i < savedParcels.length; i++) {
        const group = this.createItem('ep');
        this.echangeParcelleData.push(group);
        this.echangeParcelleData.at(i).patchValue(savedParcels[i], { emitEvent: false });
        this.hiddenItems[i] = true;
        this.showItems[i] = false;

        const localite = savedParcels[i].refcad_localite;
        if (localite && localite !== '' && localite !== 'null') {
          this.communeSelection(localite, i, savedParcels[i].refcad_section, savedParcels[i].refcad_lieu_dit);
        }
      }

      // Ajouter l'entrée vide pour le prochain ajout
      const emptyEp = this.createItem('ep');
      this.echangeParcelleData.push(emptyEp);
      this.lineIndex = savedParcels.length;
      this.showItems[this.lineIndex] = true;
      this.itemsEchange = this.echangeParcelleData;
      this.mutating = false;
    }

    // Restaurer le brouillon de la parcelle en cours si présent
    if (saved.currentParcelForm) {
      this.echangeParcelleData.at(this.lineIndex).patchValue(saved.currentParcelForm, { emitEvent: false });

      const draftLocalite = saved.currentParcelForm.refcad_localite;
      if (draftLocalite && draftLocalite !== '' && draftLocalite !== 'null') {
        this.communeSelection(draftLocalite, this.lineIndex, saved.currentParcelForm.refcad_section, saved.currentParcelForm.refcad_lieu_dit);
      }
    }

    // Marquer les champs restaurés comme dirty pour éviter les faux positifs de validation
    this.markFilledControlsDirty(this.typeVenteData.at(0));
    this.markFilledControlsDirty(this.modalitePaiementData.at(0));
    this.markFilledControlsDirty(this.echangeMontantData.at(0));
    this.markFilledControlsDirty(this.adjudicationData.at(0));
    for (let i = 0; i < this.echangeParcelleData.length; i++) {
      this.markFilledControlsDirty(this.echangeParcelleData.at(i));
    }
  }

  /**
   * Marque comme dirty tous les contrôles du groupe ayant une valeur non vide.
   * Nécessaire après patchValue pour que checkFieldValidity n'affiche pas
   * d'erreur sur les champs restaurés depuis le localStorage.
   */
  private markFilledControlsDirty(group: any): void {
    if (!group || !group.controls) { return; }
    Object.keys(group.controls).forEach(key => {
      const val = group.controls[key].value;
      if (val !== null && val !== '' && val !== undefined) {
        group.controls[key].markAsDirty();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-form-f/app-form-f.component.ts